import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip, Input, Select } from "antd";
import { Toggle } from "@ts-digital/vrc";
import { useIntl, FormattedMessage } from "react-intl";
import { FEATURE_TOGGLE_DOTS } from "../../../../config";
import "../style.css";

const Option = Select.Option;

const TitleAndToggle = props => {
  const {
    bodyRequest,
    preview,
    title,
    onTitleChange,
    onCategoryChange,
    isShared,
    onSharedchange,
    isPublic,
    onPublicChange,
    error,
    onSetError,
    isDots,
    isDotsPreview,
    onDotsChange,
    isForDots
  } = props;

  const intl = useIntl();

  const RenderToggle = toggleType => {

    const labelText = useIntl().formatMessage({
      id:
        toggleType === "shared"
          ? "ask.pages.edit.form.isShared"
          : toggleType === "public" ? "ask.pages.edit.form.isPublic"
            : "ask.pages.edit.communityTemplates.dotsToggle"
    });

    const tooltipTitle = useIntl().formatMessage({
      id:
        toggleType === "shared"
          ? "ask.pages.edit.form.isSharedDesc"
          :  toggleType === "public" ? "ask.pages.edit.form.isPublicDesc"
            : "ask.pages.edit.communityTemplates.dotsToggleTooltip"
    });

    return (
      <div>
        <Toggle
          disabled={toggleType === "shared" ? preview : toggleType === "public" ? !isShared || preview : false}
          onChange={value =>
            toggleType === "shared"
              ? onSharedchange(value)
              : toggleType === "public" ? onPublicChange(value)
                : onDotsChange(value)
          }
          checked={toggleType === "shared" ? (isShared || isForDots) : toggleType === "public" ? isShared && isPublic : isForDots}
        />
        <label
          style={{ marginLeft: 8, marginRight: 8, verticalAlign: "middle" }}
        >
          {labelText}
        </label>
        <Tooltip
          color={"rgb(0, 80, 117)"}
          overlayClassName="askEdit-tooltip-template"
          title={tooltipTitle}
        >
          <FontAwesomeIcon
            icon={["far", "info-circle"]}
            style={{
              color: "#0090d1",
              fontSize: 16,
              verticalAlign: "middle"
            }}
          />
        </Tooltip>
      </div>
    );
  };

  const renderCategories = () => {
    let options = [];
    let tmpCat = [
      { id: "tax" },
      { id: "finance" },
      { id: "social_security" },
      { id: "accounting" },
      { id: "contract" },
      { id: "corporate" },
      { id: "tax_relief" },
      { id: "other" }
    ];
    tmpCat.map(category => {
      return options.push(<Option value={category.id}>
        <FormattedMessage id={`ask.categories.${category.id}`} />
      </Option>);
    });
    return options;
  };

  return (
    <div className={"askEdit-title" + (preview ? " preview" : "")}>
      <div className="askEdit-item-label">
        <FormattedMessage id="ask.pages.edit.form.title"/>
      </div>
      <div style={{ display: "flex" }}>
        <div className="askEdit-item-field" style={{ flex: "1 0 auto" }}>
          <Input
            disabled={preview}
            className={
              "askEdit-widget-input" + (error === "title" ? " error" : "")
            }
            value={title}
            onChange={e => {
              onSetError();
              onTitleChange(e.target.value);
            }}
          />
        </div>
      </div>
      <div className="askEdit-item-label">
        <FormattedMessage id="ask.pages.edit.communityTemplates.templateDetailCategory"  />
      </div>
      <div style={{ display: "flex" }}>
        <div className="askEdit-item-field" style={{ flex: "1 0 auto" }}>
          <Select
            disabled={preview}
            className={
              "askEdit-widget-category" + (error === "category" ? " error" : "")
            }
            placeholder={intl.formatMessage({id: "ask.pages.edit.categoryPlaceholder", defaultMessage: "Seleziona una categoria"})}
            value={!isDots ? (bodyRequest.category || undefined) : bodyRequest.categoryId}
            onChange={value => {
              onSetError();
              onCategoryChange(value);
            }}
          >
            {renderCategories()}
          </Select>
        </div>
      </div>
      {!isDotsPreview &&
        ( <>
          <div className="askEdit-title-template-toggles">
            {RenderToggle("shared")}
            {RenderToggle("public")}
          </div>
          { FEATURE_TOGGLE_DOTS === "true" &&
              <div className="askEdit-title-template-dots-toggle">
                {RenderToggle("dots")}
              </div>
          }
        </>
        )
      }
    </div>
  );
};
export default TitleAndToggle;
